export const PROJECT_COLORS = ['crimson', 'moss', 'ochre', 'slate'] as const;

export type ProjectColor = (typeof PROJECT_COLORS)[number];

export const PROJECT_COLOR_HEX: Record<ProjectColor, string> = {
  crimson: '#a6113a',
  moss: '#5a6f3f',
  ochre: '#b07a1a',
  slate: '#566173',
};

export const PROJECT_COLOR_LABELS: Record<ProjectColor, string> = {
  crimson: 'Crimson',
  moss: 'Moss',
  ochre: 'Ochre',
  slate: 'Slate',
};
